module.exports = __webpack_public_path__ + "static/media/tlumacz.ed8b56c8.svg";